import { Form } from "@/components/ui/form";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { MezzaFormField } from "@/components/core/Form/MezzaFormField";
import { useForgotPasswordForm } from "../hooks/useForgotPasswordForm";
import { ButtonWithLoading } from "@/components/core/Form/ButtonWithLoading";
import { CheckCircle2 } from "lucide-react";
import { AuthPageLayout } from "@/components/layout/AuthPageLayout";
import { useAuthPageInteraction } from "@/hooks/useAuthPageInteraction";

export function ForgotPassword() {
  const { t } = useTranslation();
  const location = useLocation();
  const initialEmail = location.state?.email || "";
  const { form, handleSubmit, isLoading, isSuccess } = useForgotPasswordForm(initialEmail);
  const { hasBeenInteracted, handleFormFocus } = useAuthPageInteraction();

  return (
    <AuthPageLayout hasBeenInteracted={hasBeenInteracted}>
      <div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight">
          {t("auth.forgotPassword")}
        </h2>
        {!isSuccess && (
          <p className="mt-2 text-center text-sm text-muted-foreground">
            {t("auth.forgotPasswordDescription")}
          </p>
        )}
      </div>

      {isSuccess ? (
        <div className="flex flex-col items-center justify-center space-y-4 py-8">
          <CheckCircle2 className="h-16 w-16 text-green-500" />
          <h3 className="text-xl font-semibold text-center">
            {t("auth.passwordResetEmailSent")}
          </h3>
          <p className="text-sm text-muted-foreground text-center max-w-sm">
            {t("auth.passwordResetEmailSentDescription")}
          </p>
          <Link
            to="/login"
            className="text-sm hover:underline mt-4"
          >
            {t("auth.backToLogin")}
          </Link>
        </div>
      ) : (
        <>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(handleSubmit)}
              className="mt-8 space-y-6"
            >
              <div className="space-y-4">
                <MezzaFormField
                  form={form}
                  name="email"
                  placeholder="auth.email"
                  type="email"
                  inputMode="email"
                  onMouseDown={handleFormFocus}
                />
              </div>

              <ButtonWithLoading
                type="submit"
                className="w-full"
                disabled={isLoading}
                isLoading={isLoading}
              >
                {t("auth.sendResetLink")}
              </ButtonWithLoading>
            </form>
          </Form>

          <div className="text-center mt-4">
            <Link
              to="/login"
              className="text-sm hover:underline"
            >
              {t("auth.backToLogin")}
            </Link>
          </div>
        </>
      )}
    </AuthPageLayout>
  );
}
